var $1e8678632c464b6d$exports = {};
$1e8678632c464b6d$exports = {
    "Empty": `\u{386}\u{3B4}\u{3B5}\u{3B9}\u{3BF}`
};


export {$1e8678632c464b6d$exports as default};
//# sourceMappingURL=el-GR.module.js.map
